const inviteUserWidget = {
  openButton: "+ Bjóða notanda",
  heading: "Bjóða notanda í verkefni",
  emailLabel: "Netfang:",
  emailPlaceholder: "notandi@example.com",
  projectLabel: "Verkefni:",
  roleLabel: "Hlutverk:",
  roleResearcher: "Rannsakandi",
  rolePi: "Ábyrgðarmaður (PI)",
  expiryLabel: "Rennur út eftir:",
  expiryOptions: {
    hours24: "24 klukkustundir (1 dagur)",
    hours72: "72 klukkustundir (3 dagar)",
    hours168: "168 klukkustundir (7 dagar)",
    hours336: "336 klukkustundir (14 dagar)",
    hours720: "720 klukkustundir (30 dagar)",
  },
  sendButton: "Senda boð",
  sending: "Sendi...",
  successMessage: 'Boð sent á {{email}} fyrir verkefnið "{{project}}".',
  errorFallback: "Ekki tókst að senda boð.",
};

export default inviteUserWidget;
